export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  cover: string;
  category: string;
  author: string;
  publishDate: string;
  readTime: string;
  tags: string[];
  isHot: boolean;
}

export const articles: Article[] = [
  {
    id: "a001",
    title: "2025年最值得期待的十部国产大片，每一部都不容错过",
    excerpt: "从史诗级古装巨制到现代悬疑力作，国产电影在2025年迎来了全面爆发。本文为你盘点今年最值得期待的十部国产电影。",
    content: `<p>2025年对于中国电影市场来说，注定是不平凡的一年。随着电影工业体系的不断完善和创作水平的持续提升，越来越多的优秀国产电影正在涌现。本文将为大家盘点2025年最值得期待的十部国产大片。</p>
    <h2>1. 《封神第二部》</h2>
    <p>继第一部取得口碑和票房双丰收后，《封神第二部》将继续讲述姬发与殷寿之间的正邪对决。导演乌尔善表示，第二部的视效将全面升级，神仙斗法的场面会更加震撼。预计将在暑期档与观众见面。</p>
    <h2>2. 《流浪地球3》</h2>
    <p>郭帆导演的《流浪地球》系列已经成为中国科幻电影的标杆。第三部将延续前两部的故事线，讲述人类在流浪地球计划中面临的新危机。据悉，本片将引入更多原创科幻概念。</p>
    <h2>3. 《哪吒2》</h2>
    <p>光线彩条屋打造的《哪吒之魔童闹海》续作，将继续讲述哪吒在封神世界中的冒险故事。前作以50亿票房刷新了中国动画电影纪录，续集备受期待。</p>
    <h2>4. 《红海行动2：蛟龙出击》</h2>
    <p>林超贤导演再次执导军事动作大片，蛟龙突击队将执行更加惊险的国际救援任务。影片延续了前作的高强度写实风格，动作场面更加震撼。</p>
    <h2>5. 《长津湖之水门桥》续作</h2>
    <p>抗美援朝系列的全新力作，继续讲述志愿军战士的英勇故事。影片将聚焦朝鲜战场上的关键战役，展现中国军人的铁血精神。</p>
    <h2>6. 《深海2》</h2>
    <p>田晓鹏导演在《深海》获得成功后，继续探索动画电影的艺术边界。续作将采用更加先进的粒子水墨技术，视觉效果值得期待。</p>
    <h2>7. 《三大队2》</h2>
    <p>陈思诚监制的悬疑犯罪系列新作，继续讲述刑警追凶的故事。影片延续了前作的写实风格和扎实的剧本功底。</p>
    <h2>8. 《飞驰人生3》</h2>
    <p>韩寒导演的赛车喜剧系列第三部，沈腾将继续饰演张驰。影片将在保持喜剧风格的同时，带来更加刺激的赛车场面。</p>
    <h2>9. 《消失的她2》</h2>
    <p>陈思诚导演的悬疑系列新作，将继续探索人性深处的黑暗面。前作以35亿票房证明了中国悬疑片的巨大市场潜力。</p>
    <h2>10. 《我和我的祖国》系列新作</h2>
    <p>主旋律系列电影的全新篇章，将聚焦新时代中国发展的重大成就，以小人物故事展现大国崛起。</p>
    <p>以上就是2025年最值得期待的十部国产电影。你最期待哪一部呢？欢迎在评论区留言讨论！</p>`,
    cover: "https://readdy.ai/api/search-image?query=A%20cinematic%20banner%20showcasing%20Chinese%20movie%20posters%20collage%20with%20dramatic%20lighting%2C%20warm%20golden%20spotlights%20on%20red%20curtain%20background%2C%20film%20festival%20atmosphere%2C%20grand%20cinema%20aesthetic&width=800&height=450&seq=article-cover-001&orientation=landscape",
    category: "影视资讯",
    author: "影评人小王",
    publishDate: "2025-06-15",
    readTime: "8分钟",
    tags: ["国产电影", "2025", "院线"],
    isHot: true,
  },
  {
    id: "a002",
    title: "豆瓣评分9.0以上的冷门佳作，错过一部都是遗憾",
    excerpt: "有些电影虽然知名度不高，但质量却出奇地好。本文为你推荐十部豆瓣评分9.0以上的冷门佳作，每一部都值得细细品味。",
    content: `<p>在浩瀚的电影海洋中，有些作品因为宣传不足或题材小众而被大众忽视，但它们却拥有极高的艺术价值和观影体验。今天，我们就来盘点十部豆瓣评分9.0以上的冷门佳作。</p>
    <h2>1. 《小鞋子》（伊朗，1997）</h2>
    <p>豆瓣评分：9.2。一部关于贫穷与纯真的伊朗电影，讲述一对兄妹共用一双鞋子上学的故事。影片以儿童的视角展现了底层人民的生活，简单却感人至深。</p>
    <h2>2. 《完美的世界》（美国，1993）</h2>
    <p>豆瓣评分：9.1。克林特·伊斯特伍德执导，凯文·科斯特纳主演。一个逃犯与一个小男孩之间的公路故事，关于自由、成长与救赎。结局令人泪目。</p>
    <h2>3. 《海上钢琴师》加长版（意大利，1998）</h2>
    <p>豆瓣评分：9.3。蒂姆·罗斯主演的经典之作。虽然广为人知，但加长版包含了许多被删减的精彩片段。1900的故事永远触动人心。</p>
    <h2>4. 《活着》（中国，1994）</h2>
    <p>豆瓣评分：9.3。张艺谋导演，葛优、巩俐主演。改编自余华同名小说，跨越数十年的中国历史变迁中一个小人物的悲欢离合。</p>
    <h2>5. 《狩猎》（丹麦，2012）</h2>
    <p>豆瓣评分：9.1。麦斯·米科尔森封神之作。一个无辜的幼儿园老师被诬陷性侵儿童，整个小镇对他展开了一场可怕的"狩猎"。人性的黑暗面被展现得淋漓尽致。</p>
    <h2>6. 《无人知晓》（日本，2004）</h2>
    <p>豆瓣评分：9.1。是枝裕和导演代表作。根据真实事件改编，四个被母亲遗弃的孩子在东京公寓里独自生存的故事。柳乐优弥14岁即获戛纳影帝。</p>
    <h2>7. 《一次别离》（伊朗，2011）</h2>
    <p>豆瓣评分：9.1。奥斯卡最佳外语片。一个看似简单的离婚纠纷，却牵扯出信仰、阶层、法律的复杂交织。剧本精妙到令人叹服。</p>
    <h2>8. 《辩护人》（韩国，2013）</h2>
    <p>豆瓣评分：9.2。宋康昊主演。以韩国前总统卢武铉为原型，讲述一个税务律师转变为民主辩护律师的故事。"岩石再坚硬也是死的，鸡蛋再脆弱也有生命。"</p>
    <h2>9. 《窃听风暴》（德国，2006）</h2>
    <p>豆瓣评分：9.2。奥斯卡最佳外语片。东德秘密警察在监听一位剧作家时，逐渐被艺术和人性的力量所感化。结尾那本书的题词，令人动容。</p>
    <h2>10. 《沉静如海》（法国，2004）</h2>
    <p>豆瓣评分：9.1。二战背景下，一个法国女孩与住在她家的德国军官之间克制而深沉的爱情。全片男女主角只有一句对白，却胜过千言万语。</p>
    <p>这些电影也许没有华丽的特效和喧嚣的宣传，但它们用真诚的叙述和深刻的情感打动了无数观众。希望你能在这些冷门佳作中找到属于自己的感动。</p>`,
    cover: "https://readdy.ai/api/search-image?query=A%20collection%20of%20arthouse%20film%20posters%20in%20warm%20vintage%20tones%2C%20soft%20cinema%20projector%20light%20illuminating%20film%20reels%2C%20nostalgic%20independent%20cinema%20atmosphere%2C%20artistic%20composition&width=800&height=450&seq=article-cover-002&orientation=landscape",
    category: "影视推荐",
    author: "电影发烧友老张",
    publishDate: "2025-06-10",
    readTime: "10分钟",
    tags: ["冷门佳作", "高分电影", "豆瓣"],
    isHot: true,
  },
  {
    id: "a003",
    title: "从《狂飙》到《繁花》：国产剧的品质升级之路",
    excerpt: "近年来国产剧的质量有了质的飞跃，从《狂飙》到《繁花》，我们看到了中国电视剧的无限可能。",
    content: `<p>曾几何时，"国产剧"三个字一度成为"注水""粗制滥造"的代名词。然而近五年来，一批高质量国产剧的涌现彻底改变了观众的认知。从《隐秘的角落》到《狂飙》，从《漫长的季节》到《繁花》，国产剧正在经历一场深刻的品质革命。</p>
    <h2>精品短剧的崛起</h2>
    <p>以《隐秘的角落》《沉默的真相》为代表的迷雾剧场系列，开创了国产精品短剧的先河。12集的体量、电影级的制作水准、扎实的剧本功底，让观众看到了国产剧的另一种可能。</p>
    <p>《漫长的季节》更是将这种趋势推向了新的高度。辛爽导演用诗意的镜头语言，将东北工业城市的衰败与人物的命运交织在一起，豆瓣评分高达9.4，成为年度口碑最高的国产剧。</p>
    <h2>题材的多元化探索</h2>
    <p>《狂飙》将扫黑除恶题材与人物成长故事完美结合，张颂文饰演的高启强成为了现象级的荧幕角色。这部剧不仅收视率爆表，更引发了全社会对扫黑除恶工作的广泛讨论。</p>
    <p>《繁花》则展现了王家卫导演独特的美学风格。用光影和色彩营造出上海90年代的独特氛围，胡歌、马伊琍、唐嫣等演员的精彩演绎让这部剧成为了一场视觉盛宴。</p>
    <h2>流媒体平台的推动作用</h2>
    <p>爱奇艺、腾讯视频、优酷等流媒体平台的竞争，客观上推动了国产剧质量的提升。平台方更愿意投资精品内容，给创作者更大的创作空间。</p>
    <h2>未来展望</h2>
    <p>随着观众审美水平的不断提高和行业制作水准的持续进步，我们有理由相信，国产剧的黄金时代才刚刚开始。期待更多像《狂飙》《繁花》这样的优秀作品不断涌现。</p>`,
    cover: "https://readdy.ai/api/search-image?query=A%20collage%20of%20popular%20Chinese%20TV%20drama%20scenes%20with%20warm%20cinematic%20lighting%2C%20dramatic%20character%20moments%2C%20golden%20and%20amber%20tones%2C%20premium%20television%20aesthetic&width=800&height=450&seq=article-cover-003&orientation=landscape",
    category: "影视资讯",
    author: "剧评人小李",
    publishDate: "2025-06-08",
    readTime: "7分钟",
    tags: ["国产剧", "狂飙", "繁花"],
    isHot: true,
  },
  {
    id: "a004",
    title: "Netflix 2025下半年片单发布，这些原创内容值得关注",
    excerpt: "Netflix公布了2025年下半年的内容计划，多部重量级原创作品即将上线，涵盖电影、剧集、纪录片等多个类型。",
    content: `<p>全球流媒体巨头Netflix近日公布了2025年下半年的内容发布计划，数十部原创作品即将陆续上线。我们从中挑选了最值得关注的几部作品，供大家参考。</p>
    <h2>重磅电影</h2>
    <p><strong>《灰影人2》</strong>：瑞恩·高斯林和罗素兄弟再度联手，延续第一部的高强度动作风格。据悉续集的制作预算再创新高，动作场面将全面升级。</p>
    <p><strong>《利刃出鞘3》</strong>：丹尼尔·克雷格回归饰演神探布兰克，莱恩·约翰逊继续执导。全新阵容，全新案件，值得期待。</p>
    <h2>原创剧集</h2>
    <p><strong>《怪奇物语》最终季</strong>：这部陪伴了全球观众多年的科幻恐怖剧集即将迎来大结局。制作团队承诺将给所有角色一个圆满的交代。</p>
    <p><strong>《鱿鱼游戏》第三季</strong>：黄东赫导演将继续执导这部全球现象级剧集。第三季将揭示游戏的最终真相。</p>
    <h2>纪录片系列</h2>
    <p><strong>《我们的星球III》</strong>：大卫·爱登堡爵士再次担任旁白，用最先进的摄影技术记录地球的壮丽景观和生命奇迹。</p>
    <h2>亚洲原创</h2>
    <p>Netflix继续加大对亚洲内容的投入，多部韩剧、日剧和中文原创作品将在下半年陆续上线，进一步丰富亚洲用户的内容选择。</p>
    <p>随着下半年内容计划的公布，Netflix展现了其在原创内容领域的持续投入和创新能力。对于全球观众来说，2025年下半年将是一个内容盛宴。</p>`,
    cover: "https://readdy.ai/api/search-image?query=A%20Netflix%20branded%20content%20showcase%20with%20red%20and%20black%20theme%2C%20various%20show%20thumbnails%20arranged%20in%20grid%2C%20modern%20streaming%20platform%20interface%20aesthetic%2C%20warm%20ambient%20lighting&width=800&height=450&seq=article-cover-004&orientation=landscape",
    category: "影视资讯",
    author: "流媒体观察员",
    publishDate: "2025-06-05",
    readTime: "6分钟",
    tags: ["Netflix", "片单", "流媒体"],
    isHot: false,
  },
  {
    id: "a005",
    title: "动画电影为什么越来越好看？深度解析国产动画崛起",
    excerpt: "从《大圣归来》到《哪吒》，再到《深海》，国产动画电影用十年时间完成了从低谷到巅峰的逆袭。",
    content: `<p>十年前，如果有人告诉你国产动画电影能拿下50亿票房，你可能会觉得这是天方夜谭。但今天，这一切都已成为现实。国产动画电影的崛起，是中国电影工业发展的一个缩影。</p>
    <h2>技术突破：从模仿到创新</h2>
    <p>《大圣归来》（2015）是国产动画电影的分水岭。这部制作了八年的作品，用9.56亿票房证明了中国动画电影的市场潜力。更重要的是，它让业界看到了用心做动画的回报。</p>
    <p>《哪吒之魔童降世》（2019）则将国产动画推向了新的高度。50.35亿的票房纪录至今仍是中国动画电影的巅峰。饺子导演对传统故事的现代化改编，让这个古老的神话角色焕发了新的生命力。</p>
    <p>《深海》（2023）在视觉呈现上实现了技术突破。田晓鹏导演开创的"粒子水墨"技术，将中国传统水墨画的美学与现代3D动画技术完美结合，创造出独一无二的视觉风格。</p>
    <h2>叙事升级：讲好中国故事</h2>
    <p>国产动画电影的成功不仅在于技术进步，更在于叙事能力的提升。从《白蛇：缘起》到《长安三万里》，创作者们越来越懂得如何用现代视角重新诠释传统文化。</p>
    <p>追光动画的"新神榜"和"新文化"系列，正在构建一个属于中国动画的"电影宇宙"。这种系统化的IP开发策略，显示出国产动画正在走向成熟。</p>
    <h2>未来可期</h2>
    <p>随着更多优秀人才的加入和资本市场的认可，国产动画电影的未来充满希望。《哪吒2》《深海2》等续作的推出，将进一步巩固国产动画的市场地位。</p>
    <p>国产动画的崛起不是偶然，而是无数动画人数十年如一日坚持与创新的结果。让我们期待中国动画的黄金时代！</p>`,
    cover: "https://readdy.ai/api/search-image?query=A%20Chinese%20animation%20film%20showcase%20with%20colorful%20animated%20characters%20in%20traditional%20Chinese%20art%20style%2C%20warm%20vibrant%20colors%2C%20dynamic%20composition%2C%20modern%20animation%20studio%20aesthetic&width=800&height=450&seq=article-cover-005&orientation=landscape",
    category: "影视推荐",
    author: "动画迷小陈",
    publishDate: "2025-06-01",
    readTime: "9分钟",
    tags: ["国产动画", "哪吒", "深海"],
    isHot: false,
  },
  {
    id: "a006",
    title: "如何选择适合自己的观影设备？从手机到家庭影院全攻略",
    excerpt: "不同观影设备各有优劣，本文将从手机、平板、电脑到投影仪、家庭影院，为你提供全面的选购建议。",
    content: `<p>在流媒体时代，观影设备的选择直接影响着观看体验。从随手可及的手机到沉浸式的家庭影院，不同设备各有千秋。本文将为你提供全面的观影设备选择指南。</p>
    <h2>移动设备：随时随地想看就看</h2>
    <p>手机和平板是使用频率最高的观影设备。选择观影用手机时，屏幕素质是最重要的考量因素。OLED屏幕能提供更深的黑色和更高的对比度，观影体验明显优于LCD。推荐选择支持HDR显示的机型。</p>
    <p>平板电脑由于屏幕更大，观影体验明显优于手机。iPad系列和三星Tab系列都是不错的选择，10英寸以上的屏幕能带来比较舒适的观影体验。</p>
    <h2>电脑：多任务观影两不误</h2>
    <p>笔记本电脑和台式机是最灵活的选择。如果预算允许，建议选择4K分辨率、高色域覆盖的显示器。对于笔记本，OLED屏幕或Mini-LED屏幕的机型能提供更好的观影效果。</p>
    <h2>电视：家庭观影的核心</h2>
    <p>电视仍然是家庭观影的最佳选择。选购电视时，重点关注以下参数：分辨率（建议4K起步）、屏幕技术（OLED优于QLED优于LED）、刷新率（120Hz更流畅）、以及是否支持杜比视界和HDR10+。</p>
    <p>尺寸方面，65-75英寸是目前主流家庭的黄金尺寸，观看距离在2.5-3.5米之间最为舒适。</p>
    <h2>投影仪：打造私人影院</h2>
    <p>投影仪能提供最大画面的观影体验。目前市场上的激光投影仪已经非常成熟，4K分辨率、高亮度、长寿命是选择的关键。搭配一块好幕布和环绕音响系统，就能在家中打造私人影院。</p>
    <h2>音响设备：声音同样重要</h2>
    <p>好的画面需要好的声音来配合。回音壁（Soundbar）是最便捷的升级方案，支持杜比全景声的回音壁能提供沉浸式的声音体验。预算充足的话，5.1或7.1声道的环绕音响系统是终极选择。</p>
    <h2>总结</h2>
    <p>选择观影设备时，需要综合考虑预算、空间和个人需求。最重要的是找到最适合自己的那一款，让每一次观影都成为享受。</p>`,
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20home%20theater%20setup%20with%20large%20TV%20screen%20and%20comfortable%20sofa%2C%20warm%20ambient%20lighting%2C%20clean%20minimalist%20living%20room%2C%20cozy%20entertainment%20space%20aesthetic&width=800&height=450&seq=article-cover-006&orientation=landscape",
    category: "观影指南",
    author: "数码达人阿杰",
    publishDate: "2025-05-28",
    readTime: "7分钟",
    tags: ["观影设备", "选购指南", "家庭影院"],
    isHot: false,
  },
];

export const articleCategories = ["全部", "影视资讯", "影视推荐", "观影指南"];